module.exports = __webpack_public_path__ + "img/bx-13.ddf0c887.jpg";